import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { OrganizationCompanyService } from '@core/services/entities/organization-company.service';
import { CreateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/create-organization-company.request.dto';
import { GetOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/get-organization-company.request.dto';
import { ListOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/list-organization-company.request.dto';
import { OrganizationCompanyResponseDto } from '@domain/organization-company/dtos/organization-company.response.dto';
import { UpdateCollectorOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-collector-organization-company.request.dto';
import { UpdateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-organization-company.request.dto';
import { UpdateStateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-state-organization-company.request.dto';
import { UpdatePosPreferencesOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-pos-preferences-organization-company.request.dto';
import { OrganizationCompanyRepository } from '@domain/organization-company/repositories/organization-company.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationCompanyRepositoryService
  implements OrganizationCompanyRepository {
  constructor(private organizationCompanyService: OrganizationCompanyService) { }
  create(
    request: CreateOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.create(request);
  }
  update(
    request: UpdateOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.update(request);
  }
  updateState(
    request: UpdateStateOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.updateState(request);
  }
  updatePosPreferences(
    request: UpdatePosPreferencesOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.updatePosPreferences(request);
  }

  updateCollector(
    request: UpdateCollectorOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.updateCollector(request);
  }
  show(
    request: RefId,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto>> {
    return this.organizationCompanyService.show(request);
  }
  list(
    request: ListOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<PageableResponse<OrganizationCompanyResponseDto>>> {
    return this.organizationCompanyService.list(request);
  }
  get(
    request: GetOrganizationCompanyRequestDto,
  ): Observable<ApiResponse<OrganizationCompanyResponseDto[]>> {
    return this.organizationCompanyService.get(request);
  }
}
